import { render, staticRenderFns } from "./AfipConfigView.vue?vue&type=template&id=6ecb6d80&scoped=true"
import script from "./AfipConfigView.vue?vue&type=script&lang=js"
export * from "./AfipConfigView.vue?vue&type=script&lang=js"
import style0 from "./AfipConfigView.vue?vue&type=style&index=0&id=6ecb6d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecb6d80",
  null
  
)

export default component.exports